var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCallMissGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "13px",
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-end-call",
    transform: "translate(-457.000000, -970.000000)",
    fill: "#7EC34D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(443.000000, 956.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16.3691779 L32,24.6226946 C32,25.2607065 31.3733361,25.6589559 30.8720049,25.3419819 L27.7534303,23.3588621 L27.7534303,23.9237262 C27.7534303,25.622382 26.5037887,27 24.9629326,27 L16.7904976,27 C15.2496416,27 14,25.622382 14,23.9237262 L14,17.0762738 C14,15.377618 15.2496416,14 16.7904976,14 L24.9666189,14 C26.5074749,14 27.7571165,15.377618 27.7571165,17.0762738 L27.7571165,17.6411379 L30.8756912,15.6580181 C31.3733361,15.3329165 32,15.7352298 32,16.3691779 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCallMissGreen);
export default __webpack_public_path__ + "static/media/icCallMissGreen.aefc44252d2daa7274787d6fa8a18cbe.svg";
export { ForwardRef as ReactComponent };